import { createContext, useContext } from 'react';

/** Configuração white-label carregada da API no boot (ADR-016, RN-M10-002). */
export interface WhiteLabelConfig {
  /** Nome do sistema exibido no cabeçalho/login. */
  readonly systemName: string;
  /** Cor primária (CSS) aplicada via variável. */
  readonly primaryColor: string;
  /** URL do logo, ou null para usar o default. */
  readonly logoUrl: string | null;
}

/** Default neutro — substituído pela config vinda da API no boot. */
export const DEFAULT_WHITE_LABEL: WhiteLabelConfig = {
  systemName: 'Acervo de Termos de Adesão',
  primaryColor: '#4b0082',
  logoUrl: null,
};

/**
 * Contexto de white-label. O carregamento via `GET /config` é implementado no
 * M11; aqui fica o contrato e o default aplicado antes do boot resolver.
 */
export const WhiteLabelContext = createContext<WhiteLabelConfig>(DEFAULT_WHITE_LABEL);

/** Hook de acesso à configuração white-label. */
export function useWhiteLabel(): WhiteLabelConfig {
  return useContext(WhiteLabelContext);
}
